import { Paper, Typography, Avatar } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default function IssuesLog(props) {
  return (
    <div>
      <Paper elevation={6} style={{ width: "100%", marginTop: 30 }}>
        <div style={{ padding: 16 }}>
          {props.log.map((f, idx) => (
            <div key={idx} style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                sx={{ width: 26, height: 26, marginRight: 1 }}
                alt={f.user}
                src={`https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2F${f.uid || "default"}%2FprofilePic.jpg?alt=media`}
              />
              <Typography
                style={{ paddingTop: 10, paddingBottom: 10 }}
                key={idx}
                color="secondary"
                variant="subtitle1"
              >
                {`${f.user} Status: "${f.Status}" on ${new Date(
                  f.date.seconds * 1000,
                ).toLocaleString()}   (${dayjs(
                  new Date(f.date.seconds * 1000),
                ).fromNow()})`}
              </Typography>
            </div>
          ))}
        </div>
      </Paper>
    </div>
  );
}
